import { render, staticRenderFns } from "./BookingHoverInfos.vue?vue&type=template&id=5e6ddc60&scoped=true&lang=pug"
import script from "./BookingHoverInfos.vue?vue&type=script&lang=js"
export * from "./BookingHoverInfos.vue?vue&type=script&lang=js"
import style0 from "./BookingHoverInfos.vue?vue&type=style&index=0&id=5e6ddc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6ddc60",
  null
  
)

export default component.exports